import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/leaflypackaging-com/images/services/service-step9.jpg")